export const superadminMenu: any[] = [
  {
    title: 'Dashboard',
    desc: 'Some description goes here',
    root: true,
    icon: 'flaticon-line-graph',
    page: '/admin/dashboard',
    // badge: {type: 'm-badge--danger', value: '2'},
    translate: 'MENU.DASHBOARD',
  },
  {
    title: 'Vendors',
    desc: 'Vendors Description',
    root: true,
    page: '/admin/vendors',
    icon: 'flaticon-layer',
  },
  {
    title: 'Users',
    desc: 'Users',
    root: true,
    icon: 'flaticon-users',
    page: '/admin/settings/users',
  },
  {
    title: 'Showrooms',
    desc: 'Showrooms',
    root: true,
    icon: 'flaticon-home',
    page: '/admin/settings/showrooms',
  },
  {
    title: 'Orders',
    desc: 'Orders',
    root: true,
    icon: 'flaticon-truck',
    page: '/admin/orders',
  },
  {
    title: 'Onboarding',
    desc: 'Onboarding',
    root: true,
    icon: 'flaticon-presentation-1',
    bullet: 'dot',
    submenu: [
      {
        title: 'Retailer',
        page: '/admin/onboarding-guide/retailer',
      },
      {
        title: 'Manufacturer',
        page: '/admin/onboarding-guide/manufacturer',
      },
    ],
  },
  {
    title: 'Pricing plans',
    desc: 'Pricing plans',
    root: true,
    icon: 'flaticon-map',
    page: '/admin/settings/pricing-plans',
  },
  {
    title: 'Features',
    desc: 'Features',
    root: true,
    icon: 'flaticon-list-3',
    page: '/admin/settings/features',
  },
  {
    title: 'Base catalog',
    desc: 'Base catalog',
    root: true,
    icon: 'flaticon-tool',
    page: '/admin/base-catalog',
  },
  {
    title: 'Email',
    desc: 'Email',
    root: true,
    icon: 'flaticon-email',
    bullet: 'dot',
    submenu: [
      {
        title: 'Injections',
        page: '/admin/email/injections',
      },
      {
        title: 'Types',
        page: '/admin/email/types',
      },
    ],
  },
  {
    title: 'Requests',
    desc: 'Requests',
    root: true,
    icon: 'flaticon-light',
    bullet: 'dot',
    submenu: [
      {
        title: 'New Vendor',
        page: '/admin/requests/vendors',
      },
      {
        title: 'Price Change',
        page: '/admin/requests/prices',
      },
    ],
  },
  {
    title: 'Settings',
    root: true,
    icon: 'flaticon-settings',
    page: '/admin/settings/app',
  },
]
